import { ISaveService } from "../../../../abstractions/services/actions/ISaveService";
import { FertilizacionParseRequest } from "../../../../modulos/fertilizacion/request/FertilizacionParseRequest";
import { AnalisisLaboratorioResponse } from "../../../../modulos/fertilizacion/response/AnalisisLaboratorioResponse";
import { FertilizacionParseGrpcService } from "../../../../modulos/fertilizacion/services/FertilizacionParseGrpcService";
import { fx_createLoteGrpcService } from "../../../../modulos/terceros/services/LoteGrpcService";
import { serviceProvider } from "../../../../comun/provider/ServiceProvider";
import { BaseFullScreenFormModalRender } from "../../../base/modal/BaseFullScreenFormModalRender";
import { IFormBodyRender } from "../../../definitions/form/IFormBodyRender";
import { FertilizacionCargaFormRender } from "../form/FertilizacionCargaFormRender";
import { FertilizacionRegistroLotesModalRender } from "./FertilizacionRegistroLotesModalRender";

/** Modal a pantalla completa para cargar un nuevo análisis de laboratorio.
 *  **INTERINO**: hospeda el form de carga y al "Procesar archivo" sube el Excel,
 *  lo parsea (`POST /parse`), guarda y cierra (recargando la página). La pantalla
 *  de validación de lotes se agrega después, reemplazando este modal por uno de
 *  2 estados (carga → validación) — el form body se reutiliza tal cual. */
export class FertilizacionNuevoAnalisisModalRender extends BaseFullScreenFormModalRender<
  FertilizacionParseRequest,
  AnalisisLaboratorioResponse
> {
  protected readonly elementId = "fertilizacionNuevoAnalisisModal";

  protected get title(): string {
    return "Nuevo análisis";
  }

  protected get subtitle(): string | undefined {
    return serviceProvider.getFincaSelectedService().get()?.nombreFinca;
  }

  protected get saveLabel(): string {
    return "Procesar archivo";
  }

  protected getFormBody(): IFormBodyRender {
    return new FertilizacionCargaFormRender(this._request);
  }

  protected get saveService(): ISaveService<
    FertilizacionParseRequest,
    AnalisisLaboratorioResponse
  > {
    return new FertilizacionParseGrpcService();
  }

  /** Tras el parse: cierra la carga y abre SIEMPRE el modal de registro de lotes
   *  con el análisis creado (aunque no queden pendientes, para revisar/confirmar
   *  todas las asignaciones). Reemplaza el `dispose + reload` del base. */
  protected onSaveSuccess(analisis: AnalisisLaboratorioResponse): void {
    this.dispose();
    void this._abrirRegistroLotes(analisis);
  }

  /** Carga los lotes de la finca y abre el modal de registro de lotes. */
  private async _abrirRegistroLotes(
    analisis: AnalisisLaboratorioResponse,
  ): Promise<void> {
    const lotes = await fx_createLoteGrpcService(
      analisis.fincaId,
    ).getListAsync();
    new FertilizacionRegistroLotesModalRender(analisis, lotes).init();
  }
}
